import React from 'react'

import {
  Page,
  H1,
} from '../styles'

const Error = () => (
  <Page>
    <H1>Whoops</H1>
    <p>{`Sorry, something went wrong. We're looking into it.`}</p>
  </Page>
)

export default Error



// WEBPACK FOOTER //
// ./src/views/misc/Error.jsx